import styled from '@emotion/styled';
import { ButtonBase, Typography } from '@material-ui/core';
import { ChevronLeft, LucideIcon as Icon } from 'lucide-react';

const Container = styled('div')((p) => ({
  marginBottom: p.theme.spacing(3)
}));

const SuperTitle = styled(ButtonBase)((p) => ({
  '&&': {
    fontSize: p.theme.custom.fontSize.s,
    color: p.theme.custom.colors.gray.w500,
    textTransform: 'uppercase',
    marginBottom: p.theme.spacing(),
    cursor: 'pointer'
  }
}));

const Title = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: p.theme.spacing(1),

  gap: p.theme.spacing()
}));

const Description = styled('div')((p) => ({
  marginBottom: p.theme.spacing(1)
}));

export const SideContainerHeader = ({
  def,
  onBack,
  newUx = false
}: {
  def: {
    label: React.ReactNode;
    description?: React.ReactNode;
    icon?: Icon;
    iconSrc?: string;
  };
  onBack: () => void;
  // NEW_UX: black H5 title + 16px black icon + caption/grey500 description, matching
  // the editor's inspector panels (prototype block-settings header).
  newUx?: boolean;
}) => {
  return (
    <Container>
      <SuperTitle onClick={onBack}>
        <ChevronLeft size={16} />
        {'Back'}
      </SuperTitle>
      <Title>
        {def.icon && (
          <def.icon
            size={newUx ? 16 : 20}
            color={newUx ? '#08121A' : undefined}
          />
        )}
        {def.iconSrc && <img height={20} width={20} src={def.iconSrc} alt="" />}
        <Typography
          variant={newUx ? 'h5' : 'h4'}
          style={newUx ? { color: '#08121A' } : undefined}
        >
          {def.label}
        </Typography>
      </Title>
      {def.description && (
        <Description
          style={
            newUx
              ? { fontSize: 13, fontWeight: 200, color: '#778088' }
              : undefined
          }
        >
          {def.description}
        </Description>
      )}
    </Container>
  );
};
